import React from 'react';

const Question = ({ question, addAnswer, answer, viewOnly }) => {
  const handleTextOverflow = (txt) => {
    if (txt.length > 50) {
      // return multiline text
      return txt.split(' ').map((word, i) => {
        if (i % 5 === 0) return <br key={i} />;
        else return word + ' ';
      });
    } else {
      return txt;
    }
  };

  return (
    <div className='flex flex-col gap-4 w-full'>
      <h4 className='text-2xl font-bold'>
        {handleTextOverflow(question.questionText)}
      </h4>
      <div className='flex flex-col gap-4'>
        {viewOnly
          ? question.options.map((opt) => (
              <div className='flex gap-4' key={opt}>
                <input
                  type='radio'
                  id={opt}
                  name='hosting'
                  value={opt}
                  className='hidden peer'
                  required=''
                  onClick={() => !viewOnly && addAnswer(opt)}
                  defaultChecked={answer === opt}
                />
                <label
                  htmlFor={opt}
                  className='inline-flex justify-center items-center p-3 w-full rounded-lg border-2 border-gray-200 dark:text-gray-300 dark:border-gray-700 text-gray-600 bg-gray-100 dark:bg-gray-700'>
                  <div className='block'>
                    <div
                      className='w-full text-xl'
                      style={{ wordBreak: 'break-word' }}>
                      {opt}
                    </div>
                  </div>
                </label>
              </div>
            ))
          : question.options.map((opt) => (
              <div className='flex gap-4' key={opt}>
                <input
                  type='radio'
                  id={opt}
                  name='hosting'
                  value={opt}
                  className='hidden peer'
                  required=''
                  onClick={() => !viewOnly && addAnswer(opt)}
                  defaultChecked={answer === opt}
                />
                <label
                  htmlFor={opt}
                  className='inline-flex justify-center items-center p-3 w-full text-gray-400 bg-white rounded-lg border-2 border-gray-200 cursor-pointer dark:hover:text-gray-300 dark:border-gray-700 dark:peer-checked:text-primary-300 peer-checked:border-primary-500 peer-checked:font-semibold peer-checked:text-primary-500 hover:text-gray-600 hover:bg-gray-100 dark:text-gray-500 dark:bg-gray-800 dark:hover:bg-gray-700'>
                  <div className='block'>
                    <div
                      className='w-full text-xl'
                      style={{ wordBreak: 'break-word' }}>
                      {opt}
                    </div>
                  </div>
                </label>
              </div>
            ))}
      </div>
    </div>
  );
};

export default Question;
